import { FC } from "react";
import { Typography, Card, CardContent } from "@altimateai/lego";
import { Loader } from "../../components/Loader";
import { PlaygroundAgentDetails } from "./PlaygroundAgentDetails";
import { LocalAgentDetails } from "./LocalAgentDetails";
import { LocalAgent, LocalAgentVersion } from "../hooks/useLocalAgents";
import { PlaygroundAgentInfo } from "../types";

interface AgentDetailsPanelProps {
  selectedLocalAgent: LocalAgent | null;
  selectedAgentName: string | null;
  agentDetailsLoading: boolean;
  agentDetails: PlaygroundAgentInfo | undefined;
  availableModels?: string[];
  agentVersions: LocalAgentVersion[];
  onDeleteLocalAgent: () => void;
  onUpdateLocalAgent: (updates: Partial<Omit<LocalAgent, "id" | "created_at" | "isLocal">>) => void;
  onRestoreVersion: (version: number) => void;
  onSaveAsLocal: (agentData: {
    name: string;
    description: string;
    prompt: string;
    model: string;
    source_type: "langfuse";
    source_id: string;
  }) => void;
}

export const AgentDetailsPanel: FC<AgentDetailsPanelProps> = ({
  selectedLocalAgent,
  selectedAgentName,
  agentDetailsLoading,
  agentDetails,
  availableModels,
  agentVersions,
  onDeleteLocalAgent,
  onUpdateLocalAgent,
  onRestoreVersion,
  onSaveAsLocal,
}) => {
  if (selectedLocalAgent) {
    return (
      <LocalAgentDetails
        agent={selectedLocalAgent}
        onDelete={onDeleteLocalAgent}
        onUpdate={onUpdateLocalAgent}
        availableModels={availableModels}
        agentVersions={agentVersions}
        onRestoreVersion={onRestoreVersion}
      />
    );
  }

  if (selectedAgentName) {
    if (agentDetailsLoading) {
      return <Loader label="Loading agent details..." />;
    }
    if (agentDetails) {
      return (
        <PlaygroundAgentDetails
          agentDetails={agentDetails}
          selectedAgentName={selectedAgentName}
          availableModels={availableModels}
          onSaveAsLocal={onSaveAsLocal}
        />
      );
    }
    return (
      <Card>
        <CardContent className="al-text-center al-py-8">
          <Typography className="al-text-gray-500">Failed to load agent details</Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent className="al-text-center al-py-12">
        <Typography className="al-text-gray-500">
          Select an agent from the list to view details
        </Typography>
      </CardContent>
    </Card>
  );
};
